import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import { ModalContext } from 'context/ModalContext';
import { GetMoedaDescription } from 'utils/strings';
import { Uau, MandouBem, Valeu } from 'components/icons';
import { IconSprout } from 'components/rebrand/icons';
import { nivelByMoeda } from 'components/rebrand/mappings';

const NIVEL_ROWS = [
  { coin: 'uau', icon: <Uau size={44} /> },
  { coin: 'mandou', icon: <MandouBem size={44} /> },
  { coin: 'valeu', icon: <Valeu size={44} /> },
];

export function SeloMoedasModal(props: any) {
  // const modalID = "achievement";

  const modalID = 'help-moedas-bb';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { openModal, closeModal } = useContext(ModalContext);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Saiba mais sobre os níveis de reconhecimento"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay"
        contentElement={() => (
          <div className="rb-modal rb-modal--md">
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Níveis de reconhecimento</h1>
              <p className="rb-modal__subtitle">Cada nível vale uma quantidade de selos do seu saldo.</p>
            </div>

            <div className="rb-nivel-help">
              {NIVEL_ROWS.map(row => {
                const nivel = nivelByMoeda(row.coin);
                return (
                  <div className="rb-nivel-help__row" key={row.coin}>
                    <div className="rb-nivel-help__icon">{row.icon}</div>
                    <div className="rb-nivel-help__body">
                      <div className="rb-nivel-help__title">
                        {nivel.tag}
                        <span className="rb-nivel-help__cost">
                          <IconSprout color="#3f9a2f" size={13} /> {nivel.selos} selo{nivel.selos > 1 ? 's' : ''}
                        </span>
                      </div>
                      <div className="rb-modal__text" dangerouslySetInnerHTML={{ __html: GetMoedaDescription(row.coin) }} />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="rb-modal__actions">
              <button className="rb-btn-primary" onClick={() => closeModal()}>
                Fechar
              </button>
            </div>
          </div>
        )}
      />
    </>
  );
}
